import React, { useState } from "react";
import "./JobsList.css";
import "./CareerPageContent.css";
import { Link, Links } from "react-router-dom";

const jobsData = [
    {
        location: "Pune",
        title: "Area Sales Manager",
        description: "Candidate with more than 4+ years of experience in appointing channel partners, have good contact with Architect/Interior designer can apply",
        link: "/job/area-sales-manager-3"
    },
    {
        location: "Bangalore",
        title: "Area Sales Manager",
        description: "Candidate with more than 4+ years of experience in appointing channel partners, have good contact with Architect/Interior designer can apply",
        link: "/job/area-sales-manager-2"
    },
    {
        location: "Delhi",
        title: "Area Sales Manager",
        description: "Candidate with more than 4+ years of experience in appointing channel partners, have good contact with Architect/Interior designer can apply",
        link: "/job/area-sales-manager"
    },
    {
        location: "Jamnagar",
        title: "DGM-Sales & Marketing ",
        description: "Strong channel sales experience with more than 10+ years of experience",
        link: "/job/dgm-sales-marketing"
    },
    {
        location: "Jamnagar",
        title: "Sales Coordinator",
        description: "Candidate with 2+ years of experience in coordination with channel partners/sales team and can generate the leads.",
        link: "/job/sales-coordinator"
    },
    {
        location: "Jamnagar",
        title: "BDM- Inside Sales",
        description: "Candidate having 5+ years of experience in business development, lead generation, cold calling can apply.",
        link: "/job/bdm-inside-sales"
    },
    {
        location: "Jamnagar",
        title: "BD- Inside Sales",
        description: "Candidate having 2+ years of experience in business development, lead generation, cold calling can apply.",
        link: "/job/bde-inside-sales"
    },
];

const JobsList = () => {
    const [selectedLocation, setSelectedLocation] = useState("Location");

    const handleLocationChange = (e) => {
        setSelectedLocation(e.target.value);
    };

    const filteredJobs =
        selectedLocation === "Location"
            ? jobsData
            : jobsData.filter((job) => job.location === selectedLocation);

    const locations = ["Location", "Jamnagar", "Delhi", "Bangalore", "Pune"];

    return (
        <>
            <div className="career-hero-img">
                <img className="hero-img" src="/Assets/CareerPageImages/opportunity.webp" />
            </div>
            <div className="job-list-container">
                <h2 className="job-list-heading">Career Opportunities</h2>
                <div className="job-list-filter-bar">
                    <select
                        className="job-list-location-select"
                        value={selectedLocation}
                        onChange={handleLocationChange}
                    >
                        {locations.map((loc) => (
                            <option key={loc} value={loc}>
                                {loc}
                            </option>
                        ))}
                    </select>
                    <button
                        className="job-list-clear-button"
                        onClick={() => setSelectedLocation("Location")}
                    >
                        CLEAR ALL FILTERS
                    </button>
                </div>

                <div className="job-list-list">
                    {filteredJobs.map((job, index) => (
                        <Link className="job-list-card-link" to={job.link} key={index}>
                            <div className="job-list-card">
                                <div className="job-list-location-box">{job.location}</div>
                                <div className="job-list-details">
                                    <h3 className="job-list-title">{job.title}</h3>
                                    <p className="job-list-description">
                                        {job.description.split("\n").map((line, i) => (
                                            <span key={i}>
                                                {line}
                                                <br />
                                            </span>
                                        ))}
                                    </p>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </>
    );
};

export default JobsList;
